module.exports = __webpack_public_path__ + "img/qrCode.d094cc95.svg";